// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mmR1","icon":"styles_icon__tim66"};